const split = part => `${part}`.split('.')
const flatten = path => (Array.isArray(path) ? path.reduce((a, c) => [...a, ...flatten(c)], []) : split(path))

// get the value at a flat path
const getValue = (object, path) => path.reduce((a, c) => (a ? a[c] : undefined), object)

// safely get the value at a path
const getField = (object, ...path) => getValue(object, flatten(path))

// e.g.
// getField(obj, ['a','b'], 'c', 'd.e.f', ['g', 'h.i', ['j', 'k.l.m', 'n.o.p']])

export default getField



// WEBPACK FOOTER //
// ./src/utilities/Data/getField.js